import React, { useEffect, useState } from 'react';

import { ICustomNotification } from '../../../types/custom_notifications';

import { Icons } from '../../../data/Assets';

import { SVGIcon } from '../../wrappers/SVGIcon';

interface ICustomNotificationSidebar {
    currOption: number[];
    customNotifications: ICustomNotification[];
    setCustomNotifications: React.Dispatch<React.SetStateAction<ICustomNotification[]>>;
    setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
    isResetNew: boolean;
    setIsResetNew: React.Dispatch<React.SetStateAction<boolean>>;
};

const CustomNotificationSidebar = ({ currOption, setCurrOption, customNotifications, setCustomNotifications, isResetNew, setIsResetNew }: ICustomNotificationSidebar) => {
    const [treeStack, setTreeStack] = useState<{ noti: number, comp: number, func: number, param: number }[]>([]);

    const [showNewCustomNotification, setShowNewCustomNotification] = useState<boolean>(false);
    const [showNewNotificationComponent, setShowNewNotificationComponent] = useState<boolean>(false);
    const [showNewNotificationFunction, setShowNewNotificationFunction] = useState<boolean>(false);
    const [showNewNotificationParameter, setShowNewNotificationParameter] = useState<boolean>(false);

    const [showCustomNotification, setShowCustomNotification] = useState<Set<number>>(new Set());
    const [showNotificationComponent, setShowNotificationComponent] = useState<{ noti: number, comp: number }[]>([]);
    const [showNotificationFunction, setShowNotificationFunction] = useState<{ noti: number, comp: number, func: number }[]>([]);

    // const resetStack = () => {
    //     setCurrOption([customNotifications.length]);
    //     setTreeStack([]);
    //     setShowCustomNotification(new Set());
    //     setShowNotificationComponent([]);
    //     setShowNotificationFunction([]);
    // }

    useEffect(() => {
        if (isResetNew) {
            if (currOption.length === 1) {
                setTreeStack([]);
                setShowCustomNotification(new Set());
                setShowNotificationComponent([]);
                setShowNotificationFunction([]);
            }
            resetNewOptions();
            setIsResetNew(false);
        }
    }, [isResetNew]); // eslint-disable-line

    useEffect(() => {
        resetNewOptions();
    }, [customNotifications]) //eslint-disable-line

    const resetNewOptions = () => {
        setShowNewCustomNotification(false);
        setShowNewNotificationComponent(false);
        setShowNewNotificationFunction(false);
        setShowNewNotificationParameter(false);
    }

    const isSelect = (checkArr: number[]) => {
        if (checkArr.length !== currOption.length) return '';
        for (let i = 0; i < checkArr.length; i++) {
            if (checkArr[i] !== currOption[i]) return '';
        }
        return 'selected';
    }

    const isNotificationComponentExpand = (i: number, j: number) => {
        const expandComponent = showNotificationComponent.filter(comp => comp.noti === i && comp.comp === j).length !== 0;
        return expandComponent;
    }

    const isNotificationFunctionExpand = (i: number, j: number, k: number) => {
        const expandFunction = showNotificationFunction.filter(func => func.noti === i && func.comp === j && func.func === k).length !== 0;
        return expandFunction;
    };

    const expandOrContractCustomNotification = (i: number) => {
        setCurrOption([i]);
        resetNewOptions();

        const hasCustomNotification = treeStack.filter(stack => stack.noti === i).length;
        if (hasCustomNotification) {
            setTreeStack((prev) => prev.filter(stack => stack.noti !== i));
            const delCustomNotification = showCustomNotification;
            delCustomNotification.delete(i);
            setShowCustomNotification(delCustomNotification);
        } else {
            const oldCustomNotification = [...showCustomNotification, i];
            setShowCustomNotification(new Set([...oldCustomNotification]));
            setTreeStack([...treeStack, { noti: i, comp: -1, func: -1, param: -1 }]);
        }
    }

    const expandOrContractNotificationComponent = (i: number, j: number) => {
        setCurrOption([i, j]);
        resetNewOptions();

        const hasFunction = treeStack.filter(stack => stack.noti === i && stack.comp === j).length;
        if (hasFunction) {
            setTreeStack((prev) => prev.filter(stack => !(stack.noti === i && stack.comp === j)));
            setShowNotificationComponent((prev) => prev.filter(comp => !(comp.noti === i && comp.comp === j)));
        } else {
            setShowNotificationComponent([...showNotificationComponent, { noti: i, comp: j }]);
            setTreeStack([...treeStack, { noti: i, comp: j, func: -1, param: -1 }]);
        }
    }

    const expandOrContractNotificationFunction = (i: number, j: number, k: number) => {
        setCurrOption([i, j, k]);
        resetNewOptions();

        const hasParameter = treeStack.filter(stack => stack.noti === i && stack.comp === j && stack.func === k).length;
        if (hasParameter) {
            setTreeStack((prev) => prev.filter(stack => !(stack.noti === i && stack.comp === j && stack.func === k)));
            setShowNotificationFunction((prev) => prev.filter(func => !(func.noti === i && func.comp === j && func.func === k)));
        } else {
            setShowNotificationFunction([...showNotificationFunction, { noti: i, comp: j, func: k }]);
            setTreeStack([...treeStack, { noti: i, comp: j, func: k, param: -1, }]);
        }
    }

    const handleCreateCustomNotificationNav = () => {
        // resetStack();
        setCurrOption([customNotifications.length]);
        expandOrContractCustomNotification(customNotifications.length);
        // setTreeStack([...treeStack, { noti: customNotifications.length, comp: -1, func: -1, param: -1 }]);
        setShowNewCustomNotification(true);
    }

    const handleCreateNotificationComponentNav = (i: number) => {
        setCurrOption([i, customNotifications[i].notification_components.length]);
        expandOrContractNotificationComponent(i, customNotifications[i].notification_components.length);
        // setTreeStack([...treeStack, { noti: i, comp: customNotifications[i].notification_components.length+1, func: -1, param: -1 }]);
        setShowNewNotificationComponent(true);
    }

    const handleCreateNotificationFunctionNav = (i: number, j: number) => {
        setCurrOption([i, j, customNotifications[i].notification_components[j].notification_functions.length]);
        expandOrContractNotificationFunction(i, j, customNotifications[i].notification_components[j].notification_functions.length);
        // setTreeStack([...treeStack, { noti: i, comp: j, func: customNotifications[i].notification_components[j].notification_functions.length, param: -1 }]);
        setShowNewNotificationFunction(true);
    }

    const handleCreateNNotificationParameterNav = (i: number, j: number, k: number) => {
        setCurrOption([i, j, k, customNotifications[i].notification_components[j].notification_functions[k].notification_parameters.length]);
        // setTreeStack([...treeStack, { noti: i, comp: j, func: k, param: customNotifications[i].notification_components[j].notification_functions[k].notification_parameters.length }]);
        setShowNewNotificationParameter(true);
    }

    const isAddButtonDisabled = (type: string) => {
        const commonCondition = showNewCustomNotification || showNewNotificationComponent || showNewNotificationFunction || showNewNotificationParameter;

        switch (type) {
            case 'notification':
                return commonCondition;
            case 'component':
                return !customNotifications?.length || commonCondition || currOption.length < 1;
            case 'function':
                return !customNotifications[currOption[0]]?.notification_components?.length || commonCondition || currOption.length < 2;
            case 'parameter':
                return !customNotifications[currOption[0]]?.notification_components[currOption[1]]?.notification_functions?.length || commonCondition || currOption.length < 3;
            default:
                return false;
        }
    }

    return (
        <div className='side_bar'>
            <div className='options'>
                <button disabled={isAddButtonDisabled('notification')} onClick={handleCreateCustomNotificationNav}><SVGIcon src={Icons.Plus} />Notification</button>
                <button disabled={isAddButtonDisabled('component')} onClick={() => handleCreateNotificationComponentNav(currOption[0])}><SVGIcon src={Icons.Plus} />Component</button>
                <button disabled={isAddButtonDisabled('function')} onClick={() => handleCreateNotificationFunctionNav(currOption[0], currOption[1])}><SVGIcon src={Icons.Plus} />Function</button>
                <button disabled={isAddButtonDisabled('parameter')} onClick={() => handleCreateNNotificationParameterNav(currOption[0], currOption[1], currOption[2])}><SVGIcon src={Icons.Plus} />Parameter</button>
            </div>
            <div className='options_tree'>
                {showNewCustomNotification && <div id="new_notification" className={`category cont selected`} onClick={() => setCurrOption([customNotifications.length])}>
                    <SVGIcon src={Icons.TriangleFill} /> <p>New Notification</p>
                </div>}
                {customNotifications.map((customNotification, i) => (
                    <div key={i}>
                        <div className={`category cont ${isSelect([i])} ${showCustomNotification.has(i) ? 'rotate_svg' : ''}`} onClick={() => expandOrContractCustomNotification(i)}>
                            <SVGIcon src={Icons.TriangleFill} /> <p>{`[${customNotification.method}] ${customNotification.notification.title ?? ''}`}</p>
                        </div>

                        {showNewNotificationComponent && currOption[0] === i && <div id="new_component" className={`program cont selected`} onClick={() => setCurrOption([i, customNotifications[i].notification_components.length])}>
                            <SVGIcon src={Icons.TriangleFill} /> <p>New Component</p>
                        </div>}
                        {showCustomNotification.has(i) && customNotification.notification_components.map((notificationComponent, j) => (
                            <div key={j}>
                                <div className={`program cont ${isSelect([i, j])} ${isNotificationComponentExpand(i, j) ? 'rotate_svg' : ''}`} onClick={() => expandOrContractNotificationComponent(i, j)}>
                                    <SVGIcon src={Icons.TriangleFill} /> <p>[{notificationComponent.method}] {notificationComponent.description.length > 40 ? notificationComponent.description.slice(0, 40) + "..." : notificationComponent.description}</p>
                                </div>

                                {showNewNotificationFunction && currOption[0] === i && currOption[1] === j && <div id="new_function" className={`component cont selected`} onClick={() => setCurrOption([i, j, customNotifications[i].notification_components[j].notification_functions.length])}>
                                    <SVGIcon src={Icons.TriangleFill} /> <p>New Function</p>
                                </div>}
                                {isNotificationComponentExpand(i, j) && notificationComponent.notification_functions.map((notificationFunction, k) => (
                                    <div key={k}>
                                        <div className={`component cont ${isSelect([i, j, k])} ${isNotificationFunctionExpand(i, j, k) ? 'rotate_svg' : ''}`} onClick={() => expandOrContractNotificationFunction(i, j, k)}>
                                            <SVGIcon src={Icons.TriangleFill} /> <p>{notificationFunction.name}</p>
                                        </div>

                                        {showNewNotificationParameter && currOption[0] === i && currOption[1] === j && currOption[2] === k && <div id="new_parameter" className={`program_function cont selected`} onClick={() => setCurrOption([i, j, k, customNotifications[i].notification_components[j].notification_functions[k].notification_parameters.length])}>
                                            <SVGIcon src={Icons.TriangleFill} /> <p>New Parameter</p>
                                        </div>}
                                        {isNotificationFunctionExpand(i, j, k) && notificationFunction.notification_parameters.map((notificationParameter, l) => (
                                            <div key={l}>
                                                <div className={`program_function cont ${isSelect([i, j, k, l])}`} onClick={() => { setCurrOption([i, j, k, l]); resetNewOptions() }}>
                                                    <SVGIcon src={Icons.TriangleFill} /> <p>{notificationParameter.name}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CustomNotificationSidebar;